exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".captuure-wrapper #capture_file_input {\n\tdisplay: none;\n}\n\n.captuure-wrapper .modal-header button {\n\theight: auto;\n}\n\n.captuure-wrapper .modal-body {\n\tpadding: 10px;\n}\n\n.captuure-wrapper .modal-body .done-icon i {\n\tfont-size: 24px;\n}\n\n.captuure-wrapper .modal-body .progress {\n\tmargin: 0;\n}\n\n.captuure-wrapper .modal-action-area .upload-icon {\n    width: 20px;\n    margin-right: 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/capture-modal/capture-modal.component.css
// module id = ../../../../../src/app/modals/capture-modal/capture-modal.component.css
// module chunks = main